// Carrier types
export default { AIRPORT: 'airport' };



// WEBPACK FOOTER //
// ./src/variables/carrierTypes.js